export default {
  methods: {
    setDraggedElementPosition(
      styleId: string,
      draggingElementClass: string,
      vOffset: number = 0,
      hOffset: number = 0,
      addStyle?: any
    ) {
      const previousStyle = document.getElementById(styleId);
      if (previousStyle) {
        document.head.removeChild(previousStyle);
      }
      const [dragged] =
        (document.getElementsByClassName(draggingElementClass) as HTMLCollectionOf<HTMLElement>) ||
        [];
      if (!dragged) return;
      const { height, width } = dragged.style;
      const [x, y] = dragged.style.transformOrigin.split(' ');

      const hC = parseFloat(height) / 2;
      let vO = vOffset;
      if (vOffset !== 0) {
        vO += (parseFloat(height) - 40) / 2;
      }

      const top = `${vO - (hC - (parseFloat(height) / 100) * parseFloat(y))}px !important`;
      const left = `${hOffset + (parseFloat(width) / 100) * parseFloat(x)}px !important`;
      const style = document.createElement('style');
      style.id = styleId;
      style.innerHTML = `.${styleId} {
        margin-top:${top};
        margin-left:${left};
        ${
          addStyle
            ? Object.entries(addStyle)
                .map(([k, v]) => `${k}:${v}`)
                .join(';')
            : ''
        }
      }`;
      document.head.appendChild(style);

      dragged.classList.add(styleId);
    },
    setDraggedElementPosition2(className: string, offsetX: number = 0, offsetY: number = 0) {
      const el = document.querySelector(className) as HTMLElement;
      const { height, width } = el.style;
      const [x, y] = el.style.transformOrigin.split(' ');

      const centerY = parseFloat(height) / 2;
      if (offsetY !== 0) {
        offsetY += (parseFloat(height) - 40) / 2;
      }

      const top = `${offsetY - (centerY - (parseFloat(height) / 100) * parseFloat(y))}px`;
      const left = `${offsetX + (parseFloat(width) / 100) * parseFloat(x)}px`;
      el.style.marginTop = top;
      el.style.marginLeft = left;
    },
  },
};
